import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  color: ${(props) => (props.disabled ? props.theme.colors.muted : props.theme.colors.brand)};
`;

export const SettingsInfo = styled.div``;

export const Header = styled.div`
  ${(p) => p.theme.typography.subHeader};
  color: ${(props) => props.theme.colors.muted};
`;

export const LinkHeader = styled(Link)`
  ${(p) => p.theme.typography.subHeader};
  text-decoration: none;
  color: ${(props) => props.theme.colors.brand};
`;

export const NavigationSubtitle = styled.p`
  display: flex;
  ${(p) => p.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
`;

export const IconWrapper = styled.div`
  margin-right: 4px;
  color: ${(props) => props.theme.colors.brand};
  opacity: 0.4;
`;
